import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-cross-sell-badge',
    templateUrl: './cross-sell-badge.component.html',
    styleUrls: ['./cross-sell-badge.component.less']
})
export class CrossSellBadgeComponent {
    @Input() crossSell: number;
    @Input() isShowIcon = true;
    @Input() isShowAbreviacao = true;
}
